






















import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class JdiDirective extends Vue {
    @Prop({default: false, type: Boolean}) must!: boolean
    @Prop({default: false, type: Boolean}) mustNot!: boolean
    @Prop({default: false, type: Boolean}) should!: boolean
    @Prop({default: false, type: Boolean}) shouldNot!: boolean
    @Prop({default: false, type: Boolean}) may!: boolean

    get classes() {
        return {
            'jdic-directive': true,
            'jdic-directive--must': this.must,
            'jdic-directive--must-not': this.mustNot,
            'jdic-directive--should': this.should,
            'jdic-directive--should-not': this.shouldNot,
            'jdic-directive--may': this.may,
        }
    }
}
